import type { WorkflowType } from '@this/domain/organization/organization2';
import React from 'react';
import {
  SubSection,
  SubSectionTitle
} from '@this/components/organization/setting/workflow_setting_section/shared';
import WorkflowSection from '@this/components/organization/setting/workflow_setting_section/workflow_section';

interface ForeignHotelSectionProps {
  foreignHotelUnderRegulationWorkflowType: WorkflowType;
  foreignHotelUnderRegulationBufferAmount: number;
  foreignHotelOverRegulationWorkflowType: WorkflowType;
  foreignHotelOverRegulationBufferAmount: number;
  handleChangeWorkflowType: (type: WorkflowType, target: string) => void;
  handleChangeBufferAmount: (amount: number, target: string) => void;
}

const ForeignHotelSection: React.FC<ForeignHotelSectionProps> = ({
  foreignHotelUnderRegulationWorkflowType,
  foreignHotelUnderRegulationBufferAmount,
  foreignHotelOverRegulationWorkflowType,
  foreignHotelOverRegulationBufferAmount,
  handleChangeWorkflowType,
  handleChangeBufferAmount
}) => {
  return (
    <SubSection>
      <SubSectionTitle>海外ホテル</SubSectionTitle>

      <WorkflowSection
        description="選択したホテルの金額が旅費規定以下の場合"
        itemLabel="ホテル"
        workflowType={foreignHotelUnderRegulationWorkflowType}
        bufferAmount={foreignHotelUnderRegulationBufferAmount}
        target="foreignHotelUnderRegulation"
        showPriceLimitOption
        onChangeWorkflowType={handleChangeWorkflowType}
        onChangeBufferAmount={handleChangeBufferAmount}
      />

      <WorkflowSection
        description="選択したホテルの金額が旅費規定を超えている場合"
        itemLabel="ホテル"
        workflowType={foreignHotelOverRegulationWorkflowType}
        bufferAmount={foreignHotelOverRegulationBufferAmount}
        target="foreignHotelOverRegulation"
        onChangeWorkflowType={handleChangeWorkflowType}
        onChangeBufferAmount={handleChangeBufferAmount}
      />
    </SubSection>
  );
};

export default ForeignHotelSection;
